import { useState } from "react";
import { kopUi } from "../../../../lib/pn/calc.js";
import { DOC_TYPES } from "../../../../lib/primary/model.js";

export const canEditPrimary = (company) => ["preparer", "submitter", "owner"].includes(company.role);
export const money = (kop) => (kop == null ? "—" : kopUi(BigInt(kop)));
// Виданий документ видаляють лише «подання» й «власник»
export const canDeleteIssued = (company) => ["submitter", "owner"].includes(company.role);
// Видалення з підтвердженням. issued — документ видавали: причина й номер документа обов'язкові. true — видалено
export async function deleteDocument(companyId, d, { issued }) {
  const what = `${DOC_TYPES[d.type].short.toLowerCase()}${d.number ? ` № ${d.number}` : ""}`;
  let qs = "";
  if (issued) {
    const reason = window.prompt(`Документ ${what} уже видано — він міг піти контрагенту. Після видалення його не відновити; події, які він зафіксував, теж буде видалено.\n\nПричина видалення:`);
    if (!reason || reason.trim().length < 3) return false;
    const confirm = window.prompt(`Щоб підтвердити, введіть номер документа (${d.number}):`);
    if (confirm == null) return false;
    qs = `?${new URLSearchParams({ reason: reason.trim(), confirm: confirm.trim() })}`;
  } else if (!window.confirm(`Видалити ${what}? Документ зникне повністю.`)) return false;
  const res = await fetch(`/api/companies/${companyId}/primary/documents/${d.id}${qs}`, { method: "DELETE", credentials: "same-origin" });
  if (!res.ok) { const j = await res.json().catch(() => ({})); window.alert(j.error || `Помилка ${res.status}`); return false; }
  return true;
}
// Повне видалення контрагента чи договору з усіма документами. issued — скільки серед них виданих: тоді причина й
// підтвердження (код контрагента / номер договору). true — видалено
export async function deleteWithDocs(url, { what, issued, docs, confirmWanted }) {
  let qs = "";
  if (issued) {
    const reason = window.prompt(`${what}: усі договори й документи (${docs}) буде видалено повністю, серед них видані (${issued}) — вони могли піти контрагенту. Відновити не вийде.\n\nПричина видалення:`);
    if (!reason || reason.trim().length < 3) return false;
    const confirm = window.prompt(`Щоб підтвердити, введіть ${confirmWanted === "ВИДАЛИТИ" ? "слово ВИДАЛИТИ" : confirmWanted}:`);
    if (confirm == null) return false;
    qs = `?${new URLSearchParams({ reason: reason.trim(), confirm: confirm.trim() })}`;
  } else if (!window.confirm(`${what}: видалити повністю${docs ? ` разом із документами (${docs})` : ""}?`)) return false;
  const res = await fetch(`${url}${qs}`, { method: "DELETE", credentials: "same-origin" });
  if (!res.ok) { const j = await res.json().catch(() => ({})); window.alert(j.error || `Помилка ${res.status}`); return false; }
  return true;
}
export const STATUS = { draft: ["чернетка", "idle"], issued: ["видано", "ok"], cancelled: ["скасовано", "bad"] };

// Завантаження отриманого чи вже підписаного документа (файл як є; той самий файл двічі не створює документа)
export function Upload({ companyId, onDone, operationId, defaultType = "contract" }) {
  const [f, setF] = useState({ type: defaultType, number: "", date: "", direction: "in" });
  const [file, setFile] = useState(null), [busy, setBusy] = useState(false), [msg, setMsg] = useState(null);
  const send = async (e) => {
    e.preventDefault();
    if (!file) return;
    setBusy(true); setMsg(null);
    const qs = new URLSearchParams({ type: f.type, filename: file.name, direction: f.direction, ...(f.number ? { number: f.number } : {}), ...(f.date ? { date: f.date } : {}), ...(operationId ? { operationId } : {}) });
    try {
      const res = await fetch(`/api/companies/${companyId}/primary/upload?${qs}`, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/vnd.etax.primary" }, body: file });
      const j = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(j.error || `Помилка ${res.status}`);
      setMsg({ ok: j.duplicate ? "Цей файл уже завантажено — відкрито наявний документ" : "Завантажено" });
      onDone?.(j.document);
    } catch (err) { setMsg({ error: err.message }); }
    setBusy(false);
  };
  return (
    <form className="primary-upload" onSubmit={send} aria-label="Завантажити документ">
      <label className="field"><span>Вид</span><select value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}>
        {Object.entries(DOC_TYPES).map(([k, t]) => <option key={k} value={k}>{t.title}</option>)}</select></label>
      <label className="field"><span>Чий документ</span><select value={f.direction} onChange={(e) => setF({ ...f, direction: e.target.value })}>
        <option value="in">отримали від контрагента</option><option value="out">наш, підписаний</option></select></label>
      <label className="field"><span>Номер</span><input value={f.number} maxLength={40} onChange={(e) => setF({ ...f, number: e.target.value })} /></label>
      <label className="field"><span>Дата</span><input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} /></label>
      <label className="field"><span>Файл (PDF, зображення, p7s, XML, DOCX, XLSX — до 20 МБ)</span>
        <input type="file" accept=".pdf,.png,.jpg,.jpeg,.p7s,.xml,.docx,.xlsx" onChange={(e) => setFile(e.target.files[0] || null)} required /></label>
      <button className="btn btn-sm" disabled={busy || !file}>{busy ? "Завантажуємо…" : "Завантажити"}</button>
      {msg && <p className={msg.error ? "error" : "muted small"} role={msg.error ? "alert" : "status"}>{msg.error || msg.ok}</p>}
    </form>
  );
}
